(function () {
	function slideUp(element, duration) {
		duration = duration || 300;
		element.style.height = element.offsetHeight + "px";
		element.offsetHeight;
		element.style.overflow = "hidden";
		element.style.transitionProperty = "height, margin, padding";
		element.style.transitionDuration = duration + "ms";
		element.style.height = "0";
		element.style.paddingTop = "0";
		element.style.paddingBottom = "0";
		element.style.marginTop = "0";
		element.style.marginBottom = "0";
		window.setTimeout(function () {
			element.style.display = "none";
			element.style.removeProperty("height");
			element.style.removeProperty("padding-top");
			element.style.removeProperty("padding-bottom");
			element.style.removeProperty("margin-top");
			element.style.removeProperty("margin-bottom");
			element.style.removeProperty("overflow");
			element.style.removeProperty("transition-duration");
			element.style.removeProperty("transition-property");
		}, duration);
	}

	function slideDown(element, duration) {
		duration = duration || 300;
		element.style.removeProperty("display");
		let displayValue = window.getComputedStyle(element).display;
		if (displayValue === "none") displayValue = "block";
		element.style.display = displayValue;
		const height = element.offsetHeight;
		element.style.overflow = "hidden";
		element.style.height = "0";
		element.style.paddingTop = "0";
		element.style.paddingBottom = "0";
		element.style.marginTop = "0";
		element.style.marginBottom = "0";
		element.offsetHeight;
		element.style.transitionProperty = "height, margin, padding";
		element.style.transitionDuration = duration + "ms";
		element.style.height = height + "px";
		element.style.removeProperty("padding-top");
		element.style.removeProperty("padding-bottom");
		element.style.removeProperty("margin-top");
		element.style.removeProperty("margin-bottom");
		window.setTimeout(function () {
			element.style.removeProperty("height");
			element.style.removeProperty("overflow");
			element.style.removeProperty("transition-duration");
			element.style.removeProperty("transition-property");
		}, duration);
	}

	const initProductAccordion = () => {
		document.querySelectorAll(".product-about__accordion-title").forEach(function (title) {
			function handler(event) {
				if (event.type === "click" || event.key === "Enter") {
					if (!title.classList.contains("active")) {
						document.querySelectorAll(".product-about__accordion-title.active").forEach(function (el) {
							el.classList.remove("active");
						});
						title.classList.add("active");
						document.querySelectorAll(".product-about__accordion-content").forEach(function (el) {
							slideUp(el, 200);
						});
						const parent = title.parentElement;
						const titleIndex = Array.from(parent.children).indexOf(title);
						const contentSiblings = Array.from(parent.children).filter(function (el) {
							return el !== title && el.classList.contains("product-about__accordion-content");
						});
						const target = contentSiblings[titleIndex];
						if (target) slideDown(target, 200);
					} else {
						title.classList.remove("active");
						const parent = title.parentElement;
						const contentSiblings = Array.from(parent.children).filter(function (el) {
							return el !== title && el.classList.contains("product-about__accordion-content");
						});
						contentSiblings.forEach(function (el) {
							slideUp(el, 200);
						});
					}
				}
			}
			title.addEventListener("click", handler);
			title.addEventListener("keydown", handler);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
